import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import {
  Phone, Mail, Gift, Send, ShoppingCart, Menu, X, ChevronDown, Store,
  Heart, Home, BookOpen, Users, Activity, Calendar, Info, MapPin, LayoutDashboard, User, CreditCard,
  Tag, Building2, ChartColumn
} from 'lucide-react';
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

import logoImg from '../../assets/img/logo.svg';

import { toggleAuthModal } from '../../store/ui';
import { logoutAction, switchCampAction, switchRoleAction } from '../../store/user';
import { fLatLongAction } from '../../store/pFilter';
import { getPreListAction, getCamperListAction } from '../../store/program';
import { getitemsincart, productCartCountAction } from '../../store/cart';
import { getCartItems } from '../../services/programService';
import { unreadCountAction } from '../../store/chat';
import { counselordetail } from '../../services/directorServices';
import { getProductsCartCountService } from '../../services/onlineStoreService';
import settings from '../../config/settings';

const BRAND = '#842014';

const s = {
  header: {
    width: '100%',
    zIndex: 500,
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
  },
  topBar: {
    backgroundColor: BRAND,
    color: 'rgba(255,255,255,0.9)',
    fontSize: '0.75rem',
    padding: '8px 16px',
  },
  topBarInner: {
    maxWidth: '1440px', // same as mainNavInner, so the two bars line up
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
  },
  topBarLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    flexWrap: 'wrap',
  },
  topBarRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    flexShrink: 0,
  },
  topLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    color: 'rgba(255,255,255,0.9)',
    textDecoration: 'none',
    transition: 'color 0.2s',
  },
  socialLinks: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  socialLink: {
    color: 'rgba(255,255,255,0.9)',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    transition: 'color 0.2s',
  },
  topRightDivider: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    borderLeft: '1px solid rgba(255,255,255,0.2)',
    paddingLeft: '16px',
  },
  userBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: 'rgba(255,255,255,0.15)',
    color: '#fff',
    border: 'none',
    padding: '4px 12px',
    borderRadius: '999px',
    cursor: 'pointer',
    fontSize: '0.75rem',
    fontWeight: '500',
    position: 'relative',
    transition: 'background-color 0.2s',
  },
  dropdownMenu: {
    position: 'absolute',
    top: 'calc(100% + 8px)',
    right: 0,
    backgroundColor: '#fff',
    border: '1px solid #e5e7eb',
    borderRadius: '10px',
    color: '#374151',
    boxShadow: '0 10px 25px rgba(0,0,0,0.12)',
    minWidth: '180px',
    overflow: 'hidden',
    zIndex: 100,
  },
  dropdownItem: {
    display: 'block',
    padding: '10px 16px',
    fontSize: '0.875rem',
    color: '#374151',
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.15s',
    borderBottom: '1px solid #f3f4f6',
  },
  dropdownItemLast: {
    borderBottom: 'none',
    color: BRAND,
    fontWeight: '600',
  },
  mainNav: (isScrolled) => ({
    width: '100%',
    transition: 'all 0.3s',
    padding: isScrolled ? '10px 0' : '14px 0',
    backgroundColor: isScrolled ? 'rgba(255,255,255,0.92)' : '#fff',
    backdropFilter: isScrolled ? 'blur(12px)' : 'none',
    boxShadow: isScrolled ? '0 2px 12px rgba(0,0,0,0.08)' : '0 1px 3px rgba(0,0,0,0.06)',
  }),
  mainNavInner: {
    maxWidth: '1440px', // room for the director links (incl. Reports) and Online Store on one row
    margin: '0 auto',
    padding: '0 16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logoWrap: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    flexShrink: 0,
  },
  desktopNav: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
  },
  // --- UPDATED NAV LINK STYLES ---
  navLink: {
    fontSize: '0.875rem',
    fontWeight: '600',
    color: '#4b5563',
    textDecoration: 'none',
    padding: '8px 10px',
    borderRadius: '6px',
    transition: 'color 0.2s',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    whiteSpace: 'nowrap',
    position: 'relative', // Critical for underline positioning
  },
  navLinkActive: {
    color: '#111827',
  },
  underline: {
    position: 'absolute',
    bottom: '0px',
    left: '20%',
    right: '20%',
    height: '3px',
    backgroundColor: '#F59E0B', // Yellow from image_e4ddf9.png
    borderRadius: '99px',
  },
  // --- END UPDATED STYLES ---
  navActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  iconBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 10px',
    borderRadius: '6px',
    fontSize: '0.875rem',
    fontWeight: '600',
    color: BRAND,
    textDecoration: 'none',
    transition: 'background-color 0.2s',
    border: 'none',
    backgroundColor: 'transparent',
    whiteSpace: 'nowrap', // Online Store / Cart stay on one line instead of growing the header
    cursor: 'pointer',
  },
  cartBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '8px 14px',
    borderRadius: '8px',
    fontSize: '0.875rem',
    fontWeight: '700',
    color: '#fff',
    backgroundColor: BRAND,
    textDecoration: 'none',
    transition: 'background-color 0.2s',
    border: 'none',
    cursor: 'pointer',
    boxShadow: '0 2px 6px rgba(132,32,20,0.3)',
  },
  unreadBadge: {
    backgroundColor: BRAND,
    color: '#fff',
    borderRadius: '999px',
    fontSize: '0.65rem',
    fontWeight: '700',
    padding: '1px 5px',
    minWidth: '16px',
    textAlign: 'center',
    lineHeight: '16px',
  },
  adminIndicator: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: '#22c55e',
    border: '2px solid #fff',
    position: 'absolute',
    top: '-2px',
    right: '-2px',
  },
  hamburger: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#4b5563',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    transition: 'color 0.2s',
  },
  mobileMenu: {
    backgroundColor: '#fff',
    borderBottom: '1px solid #f3f4f6',
    boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
    overflow: 'hidden',
  },
  mobileMenuInner: {
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    maxHeight: 'calc(100vh - 120px)',
    overflowY: 'auto',
  },
  mobileNavLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '12px 12px',
    borderRadius: '8px',
    fontSize: '0.9375rem',
    fontWeight: '500',
    color: '#374151',
    textDecoration: 'none',
    transition: 'background-color 0.15s, color 0.15s',
    borderBottom: '1px solid #f9fafb',
  },
  mobileNavLinkActive: {
    color: BRAND,
    backgroundColor: 'rgba(132,32,20,0.05)',
  },
  mobileSignIn: {
    display: 'block',
    textAlign: 'center',
    padding: '12px',
    marginTop: '8px',
    backgroundColor: BRAND,
    color: '#fff',
    borderRadius: '8px',
    fontWeight: '700',
    textDecoration: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '0.9375rem',
    width: '100%',
  },
};

// --- UPDATED NAVITEM COMPONENT ---

function NavItem({ to, icon, children, onClick, unread }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Route path={to} exact>
      {({ match }) => {
        const isActive = !!match;
        const showUnderline = isActive || isHovered;

        return (
          <NavLink
            exact
            to={to}
            onClick={onClick}
            style={{
              ...s.navLink,
              color: isHovered ? '#111827' : (isActive ? '#111827' : '#4b5563'),
              backgroundColor: isHovered && !isActive ? 'rgba(132,32,20,0.05)' : 'transparent',
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {icon}
            {children}
            {unread ? <span style={s.unreadBadge}>{unread}</span> : null}

            <AnimatePresence>
              {showUnderline && (
                <motion.div
                  key={to}
                  initial={{ opacity: 0, scaleX: 0 }}
                  animate={{ opacity: 1, scaleX: 1 }}
                  exit={{ opacity: 0, scaleX: 0 }}
                  transition={{ type: 'spring', stiffness: 400, damping: 30 }}
                  style={{
                    ...s.underline,
                    backgroundColor: '#F59E0B',
                  }}
                />
              )}
            </AnimatePresence>
          </NavLink>
        );
      }}
    </Route>
  );
}

function MobileNavItem({ to, icon, children, onClick }) {
  return (
    <NavLink
      exact
      to={to}
      onClick={onClick}
      style={s.mobileNavLink}
      activeStyle={s.mobileNavLinkActive}
    >
      {icon}
      {children}
    </NavLink>
  );
}

const Header = (props) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [userDropOpen, setUserDropOpen] = useState(false);
  const [permissions, setPermissions] = useState({});
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (props?.userProfile?.UserType === 4 && !props?.isMaintenance) {
      counselordetail(`/?counselorId=${props.userProfile._id}`).then(res => {
        if (res.data.statusCode === 1) {
          setPermissions(res.data.responseData.result.permissions || {});
        }
      });
    }
  }, [props.userProfile]);

  useEffect(() => {
    if (!props?.isMaintenance) {
      props.getPreListAction();
      if (props.loggedIn) props.getCamperListAction();
    }
    setIsAdmin(localStorage.getItem('isAdminLogin') === '1');
  }, [props.loggedIn]);

  useEffect(() => {
    if (props.loggedIn && !props?.isMaintenance) {
      getCartItems().then(res => {
        if (res?.data?.statusCode) {
          props.getitemsincart(res.data.responseData.result.length);
        }
      });
      props.unreadCountAction();
      getProductsCartCountService().then(res => {
        if (res?.data?.statusCode) {
          props.productCartCountAction(res.data.responseData.result.itemCount);
        }
      });
    }
  }, []);

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(position => {
      props.fLatLongAction([position.coords.latitude, position.coords.longitude]);
    });
  }

  const closeMobile = () => setMobileOpen(false);
  const cartCount = props.numberofcartitems !== '' ? (props.numberofcartitems + (props.productCartCount || 0)) : 0;
  const { userProfile, loggedIn, unreadCount, isTeamsEZ, campPhone, campEmail } = props;
  const userType = userProfile?.UserType;

  function formatPhone(phoneNumber) {
    phoneNumber = phoneNumber.replace(/\D/g, '');
    const cc = phoneNumber.length === 11 ? '+' + phoneNumber[0] + ' ' : '';
    const p = phoneNumber.length === 11 ? phoneNumber.substring(1) : phoneNumber;
    return `${cc}(${p.substring(0, 3)}) ${p.substring(3, 6)}-${p.substring(6)}`;
  }

  // --- Nav link sets by user type ---
  const directorLinks = (
    <>
      <NavItem to="/" icon={<LayoutDashboard size={15} />} onClick={closeMobile}>Dashboard</NavItem>
      <NavItem to="/bookings" icon={<BookOpen size={15} />} onClick={closeMobile}>Bookings</NavItem>
      {settings.USE_REPORTING_TAB && <NavItem to="/reports" icon={<ChartColumn size={15} />} onClick={closeMobile}>Reports</NavItem>}
      <NavItem to="/personnel" icon={<Users size={15} />} onClick={closeMobile}>Personnel</NavItem>
      <NavItem to="/activity" icon={<Activity size={15} />} onClick={closeMobile}>Activity List</NavItem>
      <NavItem to="/inbox" icon={<Send size={15} />} onClick={closeMobile} unread={unreadCount || null}>Inbox</NavItem>
      <NavItem to="/feeds" icon={<Info size={15} />} onClick={closeMobile}>Feeds</NavItem>
      <NavItem to="/director-camps" icon={<MapPin size={15} />} onClick={closeMobile}>Program Info</NavItem>
    </>
  );

  const counselorLinks = (
    <>
      <NavItem to="/bookings" icon={<BookOpen size={15} />} onClick={closeMobile}>Bookings</NavItem>
      <NavItem to="/my-calendar" icon={<Calendar size={15} />} onClick={closeMobile}>My Calendar</NavItem>
      <NavItem to="/activity" icon={<Activity size={15} />} onClick={closeMobile}>Activity List</NavItem>
      <NavItem to="/inbox" icon={<Send size={15} />} onClick={closeMobile}>Inbox</NavItem>
      <NavItem to="/feeds" icon={<Info size={15} />} onClick={closeMobile}>Feeds</NavItem>
      <NavItem to="/director-camps" icon={<MapPin size={15} />} onClick={closeMobile}>Program Info</NavItem>
    </>
  );

  const parentLinks = (
    <>
      <NavItem to="/" onClick={closeMobile}>Home</NavItem>
      <NavItem to="/camps" onClick={closeMobile}>Programs</NavItem>
      <NavItem to="/special-offers" onClick={closeMobile}>Special Deals</NavItem>
      <NavItem to='/about-us' onClick={closeMobile}>About Us</NavItem>
      {loggedIn && <NavItem to="/inbox" onClick={closeMobile} unread={unreadCount || null}>Inbox</NavItem>}
      {loggedIn && <NavItem to="/favorite" onClick={closeMobile}>Favorites</NavItem>}
    </>
  );

  const activeNavLinks = userType === 2 ? directorLinks : userType === 4 ? counselorLinks : parentLinks;

  // --- Mobile nav link sets ---
  const mobileDirLinks = (
    <>
      <MobileNavItem to="/" icon={<LayoutDashboard size={18} />} onClick={closeMobile}>Dashboard</MobileNavItem>
      <MobileNavItem to="/profile/information" icon={<User size={18} />} onClick={closeMobile}>Account</MobileNavItem>
      <MobileNavItem to="/users" icon={<Users size={18} />} onClick={closeMobile}>Users</MobileNavItem>
      <MobileNavItem to="/payments" icon={<CreditCard size={18} />} onClick={closeMobile}>Payments</MobileNavItem>
      <MobileNavItem to="/products-booking" icon={<ShoppingCart size={18} />} onClick={closeMobile}>Products Bookings</MobileNavItem>
      <MobileNavItem to="/online-store" icon={<Store size={18} />} onClick={closeMobile}>Online Store</MobileNavItem>
      <MobileNavItem to="/gift-cards" icon={<Gift size={18} />} onClick={closeMobile}>Gift Card</MobileNavItem>
      <MobileNavItem to="/bookings" icon={<BookOpen size={18} />} onClick={closeMobile}>Bookings</MobileNavItem>
      {settings.USE_REPORTING_TAB && <MobileNavItem to="/reports" icon={<ChartColumn size={18} />} onClick={closeMobile}>Reports</MobileNavItem>}
      <MobileNavItem to="/personnel" icon={<Users size={18} />} onClick={closeMobile}>Personnel</MobileNavItem>
      <MobileNavItem to="/activity" icon={<Activity size={18} />} onClick={closeMobile}>Activity List</MobileNavItem>
      <MobileNavItem to="/inbox" icon={<Send size={18} />} onClick={closeMobile}>Inbox</MobileNavItem>
      <MobileNavItem to="/feeds" icon={<Info size={18} />} onClick={closeMobile}>Feeds</MobileNavItem>
      <MobileNavItem to="/director-camps" icon={<MapPin size={18} />} onClick={closeMobile}>Program Info</MobileNavItem>
    </>
  );

  const mobileCounselorLinks = (
    <>
      <MobileNavItem to="/users" icon={<Users size={18} />} onClick={closeMobile}>Users</MobileNavItem>
      <MobileNavItem to="/bookings" icon={<BookOpen size={18} />} onClick={closeMobile}>Bookings</MobileNavItem>
      <MobileNavItem to="/my-calendar" icon={<Calendar size={18} />} onClick={closeMobile}>My Calendar</MobileNavItem>
      <MobileNavItem to="/activity" icon={<Activity size={18} />} onClick={closeMobile}>Activity List</MobileNavItem>
      <MobileNavItem to="/inbox" icon={<Send size={18} />} onClick={closeMobile}>Inbox</MobileNavItem>
      <MobileNavItem to="/feeds" icon={<Info size={18} />} onClick={closeMobile}>Feeds</MobileNavItem>
      <MobileNavItem to="/director-camps" icon={<MapPin size={18} />} onClick={closeMobile}>Program Info</MobileNavItem>
    </>
  );

  const mobileParentLinks = (
    <>
      {loggedIn && <MobileNavItem to="/profile/information" icon={<User size={18} />} onClick={closeMobile}>Account</MobileNavItem>}
      {loggedIn && userType !== 2 && userType !== 4 && (
        <MobileNavItem to="/profile/bookings" icon={<BookOpen size={18} />} onClick={closeMobile}>My Bookings</MobileNavItem>
      )}
      {loggedIn && userType !== 2 && userType !== 4 && (
        <MobileNavItem to={{ pathname: '/calendar', state: { type: 0 } }} icon={<Calendar size={18} />} onClick={closeMobile}>My Calendar</MobileNavItem>
      )}
      <MobileNavItem to="/" icon={<Home size={18} />} onClick={closeMobile}>Home</MobileNavItem>
      <MobileNavItem to="/camps" icon={<MapPin size={18} />} onClick={closeMobile}>Programs</MobileNavItem>
      <MobileNavItem to="/special-offers" icon={<Tag size={18} />} onClick={closeMobile}>Special Deals</MobileNavItem>
      {loggedIn && <MobileNavItem to="/inbox" icon={<Send size={18} />} onClick={closeMobile}>Inbox</MobileNavItem>}
      {loggedIn && <MobileNavItem to="/favorite" icon={<Heart size={18} />} onClick={closeMobile}>Favorites</MobileNavItem>}
      {loggedIn && <MobileNavItem to="/online-store" icon={<Store size={18} />} onClick={closeMobile}>Online Store</MobileNavItem>}
      {loggedIn && <MobileNavItem to="/feeds" icon={<Activity size={18} />} onClick={closeMobile}>Feeds</MobileNavItem>}
      {loggedIn && <MobileNavItem to="/pickup" icon={<MapPin size={18} />} onClick={closeMobile}>Authorized Pickup</MobileNavItem>}
      {loggedIn && (userType === 1 || !userType) && (
        <MobileNavItem to="/cart" icon={<ShoppingCart size={18} />} onClick={closeMobile}>
          Cart ({cartCount})
        </MobileNavItem>
      )}
      <MobileNavItem to='/about-us' icon={<Building2 size={18} />} onClick={closeMobile}>About Us</MobileNavItem>
      <MobileNavItem to="/gift-cards" icon={<Gift size={18} />} onClick={closeMobile}>Gift Card</MobileNavItem>
    </>
  );

  const activeMobileLinks = userType === 2 ? mobileDirLinks : userType === 4 ? mobileCounselorLinks : mobileParentLinks;

  return (
    <>
    <div style={{ height: props.hideNav ? '50px' : '105px' }} aria-hidden="true" />
    <header style={s.header}>
      <div style={s.topBar} className="d-none d-md-block">
        <div style={s.topBarInner}>
        <div style={{ ...s.topBarLeft, display: 'flex', flexDirection: 'column', gap: '0', padding: '2px 0' }}>
          {/* TOP ROW */}
          {(campEmail || campPhone) && (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'auto auto auto',
              alignItems: 'center',
              gap: '0 24px',
              borderBottom: '1px solid rgba(255,255,255,0.3)',
              paddingBottom: '3px',
              marginBottom: '3px'
            }}>
              <span style={{ fontWeight: '700', color: '#fff', fontSize: '11px', whiteSpace: 'nowrap' }}>
                Question about camp?
              </span>
              {campPhone ? (
                <a href={`tel:${campPhone}`} style={{ ...s.topLink, display: 'flex', alignItems: 'center', gap: '5px', color: '#fff', textDecoration: 'none', fontSize: '11px', whiteSpace: 'nowrap' }}>
                  <Phone size={10} fill="currentColor" /> <strong>{formatPhone(campPhone)}</strong>
                </a>
              ) : <span />}
              {campEmail ? (
                <a href={`mailto:${campEmail}`} target="_blank" rel="noreferrer" style={{ ...s.topLink, display: 'flex', alignItems: 'center', gap: '5px', color: '#fff', textDecoration: 'none', fontSize: '11px', whiteSpace: 'nowrap' }}>
                  <Mail size={10} /> <strong>{campEmail}</strong>
                </a>
              ) : <span />}
            </div>
          )}

          {/* BOTTOM ROW */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'auto auto auto',
            alignItems: 'center',
            gap: '0 24px'
          }}>
            <span style={{ fontWeight: '700', color: '#fff', fontSize: '11px', whiteSpace: 'nowrap' }}>
              Question about computer software?
            </span>
            <a href="tel:+19712453061" style={{ ...s.topLink, display: 'flex', alignItems: 'center', gap: '5px', color: '#fff', textDecoration: 'none', fontSize: '11px', whiteSpace: 'nowrap' }}>
              <Phone size={10} fill="currentColor" /> <strong>+1 (971)-245-3061</strong>
            </a>
            <a
              href={`mailto:${isTeamsEZ ? 'support@teamsez.com' : 'support@campsez.com'}`}
              target="_blank"
              rel="noreferrer"
              style={{ ...s.topLink, display: 'flex', alignItems: 'center', gap: '5px', color: '#fff', textDecoration: 'none', fontSize: '11px', whiteSpace: 'nowrap' }}
            >
              <Mail size={10} /> <strong>{isTeamsEZ ? 'support@teamsez.com' : 'support@campsez.com'}</strong>
            </a>
          </div>
        </div>

          <div style={s.topBarRight}>
            <div style={s.socialLinks}>
              <a href="https://www.facebook.com/CampsEZ" target="_blank" rel="noreferrer" style={s.socialLink}><FaFacebookF size={14} /></a>
              <a href="https://www.instagram.com/camps_ez/" target="_blank" rel="noreferrer" style={s.socialLink}><FaInstagram size={14} /></a>
              <a href="https://www.youtube.com/channel/UCpe_I1IlZ5zyOSp7jnH7_3A" target="_blank" rel="noreferrer" style={s.socialLink}><FaYoutube size={14} /></a>
              <a href="https://twitter.com/Camps_EZ" target="_blank" rel="noreferrer" style={s.socialLink}><FaXTwitter size={14} /></a>
              <a href="https://www.linkedin.com/company/campsez/" target="_blank" rel="noreferrer" style={s.socialLink}><FaLinkedinIn size={14} /></a>
            </div>

            {!props?.isMaintenance && (
              <div style={s.topRightDivider}>
                {!props.hideNav && (
                  <Link to="/gift-cards" style={s.topLink}>
                    <Gift size={14} /> Gift Cards
                  </Link>
                )}

                {loggedIn ? (
                  <div style={{ position: 'relative' }}>
                    <button
                      style={s.userBtn}
                      onClick={() => setUserDropOpen(o => !o)}
                    >
                      {isAdmin && <span style={s.adminIndicator} />}
                      Hello, <strong>{userProfile?.name}</strong>
                      {userProfile?.isSuperDirector && userProfile?.campName ? ` (${userProfile.campName})` : ''}
                      <ChevronDown size={12} />
                    </button>

                    <AnimatePresence>
                      {userDropOpen && (
                        <motion.div
                          initial={{ opacity: 0, y: -8, scale: 0.97 }}
                          animate={{ opacity: 1, y: 0, scale: 1 }}
                          exit={{ opacity: 0, y: -8, scale: 0.97 }}
                          transition={{ duration: 0.15 }}
                          style={s.dropdownMenu}
                          onMouseLeave={() => setUserDropOpen(false)}
                        >
                          {!props.hideNav && (
                            <>
                              <Link to="/profile/information" style={s.dropdownItem} onClick={() => setUserDropOpen(false)}>Account</Link>
                              {userProfile?.isSuperDirector && (
                                <span style={s.dropdownItem} onClick={() => { props.switchCampAction(); setUserDropOpen(false); }}>Switch Camp</span>
                              )}
                              {!!userProfile?.linkedUserType && (
                                <span style={s.dropdownItem} onClick={() => { props.switchRoleAction(userProfile.linkedUserType); setUserDropOpen(false); }}>
                                  {userProfile.linkedUserType === 4 ? 'Switch to Counsellor' : 'Switch to Parent'}
                                </span>
                              )}
                              {(userType === 2 || (userType === 4 && !!permissions.addUser)) && (
                                <Link to="/users" style={s.dropdownItem} onClick={() => setUserDropOpen(false)}>Users</Link>
                              )}
                              {userType === 2 && <Link to="/payments" style={s.dropdownItem} onClick={() => setUserDropOpen(false)}>Payments</Link>}
                              {userType === 2 && <Link to="/products-booking" style={s.dropdownItem} onClick={() => setUserDropOpen(false)}>Products Bookings</Link>}
                              {userType !== 2 && userType !== 4 && (
                                <>
                                  <Link to="/profile/bookings" style={s.dropdownItem} onClick={() => setUserDropOpen(false)}>My Bookings</Link>
                                  <Link to={{ pathname: '/calendar', state: { type: 0 } }} style={s.dropdownItem} onClick={() => setUserDropOpen(false)}>My Calendar</Link>
                                </>
                              )}
                              {userType === 1 && <Link to="/feeds" style={s.dropdownItem} onClick={() => setUserDropOpen(false)}>Feeds</Link>}
                              {(userType === 1 || !userType) && (
                                <Link to="/pickup" style={s.dropdownItem} onClick={() => setUserDropOpen(false)}>Authorized Pickup</Link>
                              )}
                            </>
                          )}
                          <span style={{ ...s.dropdownItem, ...s.dropdownItemLast }} onClick={() => { props.logoutAction(); setUserDropOpen(false); }}>
                            Log Out
                          </span>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                ) : (
                  <button
                    style={{ ...s.userBtn, backgroundColor: 'rgba(255,255,255,0.2)' }}
                    onClick={() => props.toggleAuthModal(1)}
                  >
                    Sign In
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {!props?.isMaintenance && !props.hideNav && (
        <div style={s.mainNav(isScrolled)}>
          <div style={s.mainNavInner}>
            <Link to="/" style={s.logoWrap}>
              {isTeamsEZ ? (
                <span style={{ fontSize: '1.5rem', fontWeight: '800', letterSpacing: '-0.02em', color: '#111827' }}>
                  Teams<span style={{ color: '#1c0369' }}>EZ</span>
                </span>
              ) : (
                <img
                  src={logoImg}
                  alt="CampsEZ"
                  width={149}
                  height={38}
                />
              )}
              {isAdmin && (
                <span style={{ marginLeft: '8px', backgroundColor: '#22c55e', color: '#fff', fontSize: '0.65rem', fontWeight: '700', padding: '2px 8px', borderRadius: '999px' }}>
                  ADMIN
                </span>
              )}
              {userProfile?.isSuperDirector && (
                <span style={{ marginLeft: '25px', backgroundColor: BRAND, color: '#fff', fontSize: '0.65rem', fontWeight: '700', padding: '2px 8px', borderRadius: '999px' }}>
                  SUPER DIRECTOR
                </span>
              )}
            </Link>

            <div className="d-none d-lg-flex" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <nav style={s.desktopNav}>
                {activeNavLinks}
              </nav>
              <div style={{ width: '1px', height: '20px', backgroundColor: '#e5e7eb', margin: '0 8px' }} />
              <div style={s.navActions}>
                {loggedIn && (
                  <Link
                    to="/online-store"
                    style={s.iconBtn}
                    onMouseEnter={e => { e.currentTarget.style.backgroundColor = 'rgba(132,32,20,0.08)'; e.currentTarget.style.borderRadius = '6px'; }}
                    onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                  >
                    <Store size={16} /> Online Store
                  </Link>
                )}
                {(userType === 1 || !userType || !loggedIn) && (
                  <Link
                    to="/cart"
                    style={{ ...s.iconBtn, fontWeight: '700' }}
                    onMouseEnter={e => { e.currentTarget.style.backgroundColor = 'rgba(132,32,20,0.08)'; e.currentTarget.style.borderRadius = '6px'; }}
                    onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                  >
                    <ShoppingCart size={16} />
                    Cart ({cartCount})
                  </Link>
                )}
                {/* {!loggedIn && (
                  <button onClick={() => props.toggleAuthModal(1)} style={s.cartBtn}>
                    Sign In
                  </button>
                )} */}
              </div>
            </div>

            <button
              className="d-lg-none"
              style={s.hamburger}
              onClick={() => setMobileOpen(o => !o)}
              aria-label="Toggle menu"
            >
              {mobileOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      )}

      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.22 }}
            style={s.mobileMenu}
            className="d-lg-none"
          >
            <div style={s.mobileMenuInner}>
              {userProfile?.isSuperDirector && (
                <span style={{ display: 'inline-block', marginBottom: '8px', backgroundColor: BRAND, color: '#fff', fontSize: '0.65rem', fontWeight: '700', padding: '2px 8px', borderRadius: '999px' }}>
                  SUPER DIRECTOR
                </span>
              )}
              {activeMobileLinks}

              {loggedIn && userProfile?.isSuperDirector && (
                <span
                  style={{ ...s.mobileSignIn, backgroundColor: BRAND, marginTop: '8px' }}
                  onClick={() => { props.switchCampAction(); closeMobile(); }}
                >
                  Switch Camp
                </span>
              )}

              {loggedIn && !!userProfile?.linkedUserType && (
                <span
                  style={{ ...s.mobileSignIn, backgroundColor: BRAND, marginTop: '8px' }}
                  onClick={() => { props.switchRoleAction(userProfile.linkedUserType); closeMobile(); }}
                >
                  {userProfile.linkedUserType === 4 ? 'Switch to Counsellor' : 'Switch to Parent'}
                </span>
              )}

              {!loggedIn ? (
                <button
                  style={s.mobileSignIn}
                  onClick={() => { props.toggleAuthModal(1); closeMobile(); }}
                >
                  Sign In
                </button>
              ) : (
                <span
                  style={{ ...s.mobileSignIn, backgroundColor: '#6b1a10' }}
                  onClick={() => { props.logoutAction(); closeMobile(); }}
                >
                  Log Out
                </span>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
    </>
  );
};

const mapStateToProps = state => {
  const { unreadCount } = state.chat;
  const { isTeamsEZ, campPhone, campEmail, isMaintenance } = state.ui;
  const { userProfile, loggedIn } = state.user;
  const numberofcartitems = state.cartReducer.cartitems;
  const productCartCount = state.cartReducer.productCartCount;
  return { userProfile, loggedIn, numberofcartitems, unreadCount, isTeamsEZ, productCartCount, campEmail, campPhone, isMaintenance };
};

const mapDispatchToProps = dispatch => ({
  toggleAuthModal: params => dispatch(toggleAuthModal(params)),
  getPreListAction: () => dispatch(getPreListAction()),
  logoutAction: () => dispatch(logoutAction()),
  switchCampAction: () => dispatch(switchCampAction()),
  switchRoleAction: targetUserType => dispatch(switchRoleAction(targetUserType)),
  fLatLongAction: params => dispatch(fLatLongAction(params)),
  getCamperListAction: () => dispatch(getCamperListAction()),
  getitemsincart: cartitems => dispatch(getitemsincart(cartitems)),
  unreadCountAction: () => dispatch(unreadCountAction()),
  productCartCountAction: params => dispatch(productCartCountAction(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);